module.exports = __webpack_public_path__ + "static/media/santa-reliquia-virgen-coromoto-altar-small.ba394fd0.jpg";